<template>
  <div class="reportTable">
    <section ref="print">
      <div class="mytitle">
        <ul>
          <li>
            <span>打印日期：</span>
            <span>{{ nowday }}</span>
          </li>
          <li>
            <span>打印时间：</span>
            <span>{{ nowtime }}</span>
          </li>
          <li>
            <span>酒店日期：</span>
            <span>{{ $parent.hotelInfo.dhoteltime }}</span>
          </li>
        </ul>
        <ul style="display: flex; flex-direction: column; align-items: center">
          <li>
            <span></span>
            <span>{{ $parent.hotelInfo.cname }}</span>
          </li>
          <li>
            <span></span>
            <span>{{ $parent.bbmc }}</span>
          </li>
          <li>
            <span>查询日期：</span>
            <span>{{ this.$moment(this.startDate).format("YYYY-MM-DD") }}</span>
            <span
              v-if="$parent.endTimeShow"
            >至{{ this.$moment(this.endDate).format("YYYY-MM-DD") }}</span>
          </li>
        </ul>
        <ul style="display: flex; flex-direction: column; align-items: flex-end">
          <li>
            <span>操作员:</span>
            <span>{{ $parent.userInfo.cname }}</span>
          </li>
          <!-- <li>
            <span>总页数:</span>
            <span>{{pagecount}}</span>
          </li>-->
          <li v-if="$parent.datacount > 0">
            <span>总条数:</span>
            <span>{{ $parent.datacount }}条</span>
          </li>
        </ul>
      </div>
      <!-- <div class="queryDate">
        <span>查询日期:</span>
        <el-date-picker
          v-model="queryDate"
          type="date"
          placeholder="选择日期"
          @change="dateChange"
        >
        </el-date-picker>
      </div>-->
      <div class="report">
        <div class="form-content">
          <div class="formTitle">
            <span class="zhanghao">主账号</span>
            <span class="shijian3">预定号</span>
            <span class="xingming">姓名</span>
            <span class="shijian2">抵店时间</span>
            <span class="shijian2">预离时间</span>
            <span class="fanghao">主房号</span>
            <span class="fangxing">房型</span>
            <span class="jianshu">数量</span>
            <span class="fangjia" style="text-align:right">房价</span>

            <span style="text-align:left;padding-left:10px;flex:1">同行房号</span>
          </div>
        </div>
        <div class="formContaniner">
          <transition-group name="listOfForms" tag="p">
            <div class="PreArrivalItem" v-for="(item, index) in preArrivalList" v-bind:key="index">
              <div class="zhanghao">{{ item.accNo }}</div>
              <div class="shijian3">{{ item.reseNo }}</div>
              <div  class="xingming">{{ item.guestName }}</div>
              <div class="shijian2">{{ item.arrival }} {{ item.arrTime }}</div>
              <div class="shijian2">{{ item.departure }} {{ item.depTime }}</div>
              <div  class="fanghao">{{ item.cNo }}</div>

              <div class="fangxing">
                <span v-for="(itemList, indexList) in item.roomNameAndCountVos">
                  {{ itemList.roomCDesc }}
                  <br />
                </span>
                <span
                  v-if="item.roomNameAndCountVos.length"
                  class="line"
                  style="font-weight:bold"
                >小计:</span>
              </div>
              <div class="jianshu">
                <span v-for="(itemList, indexList) in item.roomNameAndCountVos">
                  {{ itemList.count }}
                  <br />
                </span>
              </div>

              <div class="fangjia" style="text-align:right">
                <span v-for="(itemList, indexList) in item.roomNameAndCountVos">
                  {{ itemList.roomRate }}
                  <br />
                </span>
                <span v-if="item.roomNameAndCountVos.length" class="line" style="font-weight:bold">
                  {{
                  curreny(item.sum)
                  }}
                </span>
              </div>

              <div style="text-align:left;padding-left:10px;flex:1">
                <span style="margin-right:5px;" v-for="itemList in item.rooms">{{ itemList }}</span>
              </div>
            </div>
          </transition-group>
        </div>
        <!-- <div class="total">
        <div>
          <span>合计</span>
          <span>{{ record }}条记录</span>
          <span>{{ room }}间</span>
          <span>{{ total }}</span>
        </div>
        </div>-->
      </div>
    </section>
  </div>
</template>

<script>
import { getRequest } from "@/api/api1.js";
export default {
  data() {
    return {
      preArrivalList: [],
      record: 0,
      room: 0,
      total: 0,
      allPage: 0,
      userName: localStorage.getItem("cname"),
      queryDate: "",
      date: "",
      nowday:"",
      nowtime: "",
      startDate: "",
      endDate: ""
    };
  },
  created() {
    this.$parent.bbmc = "F51.同行报表";
    this.$parent.startDate = this.$moment(new Date()).format("YYYY-MM-DD");
    this.$parent.endDate = this.$moment(new Date()).format("YYYY-MM-DD");
    this.getPreArrivalList();
    this.queryDate = new Date();
    this.date = this.$moment(this.queryDate).format("YYYY-MM-DD HH:mm:ss");
    this.$parent.closeshow();
     this.$parent.chaxunvib = true;
    // this.$parent.isShow2 = false;
  },
  methods: {
      doserach(){
      this.getPreArrivalList();
    },
    dodayin() {
      this.$print(this.$refs.print);
    },
    curreny(data) {
      if (isNaN(data)) {
        let num = 0;
        return num.toFixed(2);
      } else if (data != null && data != undefined) {
        data = Number(data).toFixed(2);
        return data;
      }
    },
    dateChange(data) {
      // 
      this.date = this.$moment(data).format("YYYY-MM-DD HH:mm:ss");
    },
    getPreArrivalList() {
      let loadingInstance = this.$loading({ text: "正在查询..." });
      getRequest("/reportForFront/selectTogether").then(res => {
        
        this.$nextTick(() => {
          loadingInstance.close();
        }); //不回调
        if (res.status != 200)
          return vm.$mymessage({
            content: res.code,
            type: "error",
            time: 3000,
            hasClose: true
          });
        this.$parent.datacount = res.data.length;
        this.preArrivalList = res.data;
        res.data.forEach(element => {
          
          element.roomNameAndCountVos.forEach(item => {
            
            element.count = item.count;
            element.roomCDesc = item.roomCDesc;
            element.roomRate = item.roomRate;
          });
        });
        
        this.$store.state.preArrivalList = res.data;
        this.$store.state.preArrivalName = "F51.同行报表";
        this.record = res.data.length;
        this.allPage = Math.ceil(res.data.length / 10);
        this.nowday= this.$moment(new Date()).format('YYYY-MM-DD');
          this.nowtime= this.$moment(new Date()).format('HH:mm:ss');
          this.startDate= this.$parent.startDate;
          this.endDate= this.$parent.endDate;
      });
    }
  }
};
</script>
<style scoped>
.mytitle {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  padding: 10px !important;
  line-height: 24px;
  margin-bottom: 1em;
}

</style>